export default __webpack_public_path__ + "static/media/MP_Skills_Situation_01.6101dd25.png";